import React, { useEffect, useState } from "react";
import { CaretRight } from "@phosphor-icons/react";
import SingleProductSuggestion from "./SingleProductSuggestions";
import Modal from "../ModalImage/Modal";
import { Link, useLocation } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { database, auth } from "../firebaseConfig";
import axios from "axios";
import { Button, Input } from "reactstrap";

const DirectSingleProduct = () => {
  const location = useLocation();
  const history = useHistory();
  const { directid, selectionid } = useParams();
  const [loading, setLoading] = useState(false);

  const [directproduct, setDirectProduct] = useState({});

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Fetch product when directid is provided
  useEffect(() => {
    const fetchProduct = async () => {
      if (directid) {
        
        try {
      setLoading(true);

          const response = await axios.get(
            // `http://localhost:4000/api/karigarforweb/${directid}/${selectionid}`
            `https://dreamsjewels-stock.fly.dev/api/karigarforweb/${directid}/${selectionid}`
          );
          if(response){
      setLoading(false);
          }
          setDirectProduct(response.data.data);
        } catch (error) {
      setLoading(false);
          console.error("Error fetching direct product:", error);
        }
      }
    };
    fetchProduct();
  }, [directid]);


  const addingselection = async (code, type = "add") => {
    try {
      setLoading(true);
      await axios.post(
        // "http://localhost:4000/api/imagequeue/selection", 
        `https://dreamsjewels-stock.fly.dev/api/imagequeue/selection`,
        {
          id: selectionid,
          code,
          type
        });
      setDirectProduct((prev) => ({
        ...prev,
        selected: type === "add",
      }));
    } catch (err) {
      console.error("Error updating selection:", err);
    } finally {
      setLoading(false);
    }
  };

  // Redirect if invalid product
  if (!directid) {
    history.push("/home");
    return null;
  }

  if (loading) {
   return(
     <div className='loading'>
      <img className='loadinggif' src={process.env.PUBLIC_URL + "/images/loading.gif"} />
    </div>
   )
  }


  return (
    <div className="mainbody">
      <div className="container singleprodcontainer">
        <div className="row">
          {/* Left Side - Images */}
          <div className="col-lg-6 col-md-6 col-sm-12">
            {Array.isArray(directproduct.finalimage) &&
              directproduct.finalimage.length > 0 ? (
              directproduct.finalimage.map((imgObj, index) => (
                <div key={index}>
                  <Modal image={imgObj} alt={directproduct.type} />
                  <br />
                </div>
              ))
            )
              :
              Array.isArray(directproduct.sampleImage) &&
                directproduct.sampleImage.length > 0 ? (
                directproduct.sampleImage.map((imgObj, index) => (
                  <div key={index}>
                    <Modal image={imgObj} alt={directproduct.type} />
                    <br />
                  </div>
                ))
              )
                :
                null
            }
          </div>

          {/* Right Side - Details */}
          <div className="col-lg-6 col-md-6 col-sm-12">
            <Button
              disabled={loading}
              className={directproduct.selected ? "cancelclass directprodselbtn" : "selectclass directprodselbtn"}
              onClick={() =>
                addingselection(directproduct.code || directproduct.samplecode, directproduct.selected ? "remove" : "add")
              }
            >
              {loading
                ? "Please wait..."
                : directproduct.selected
                  ? "Remove"
                  : "Select"}
            </Button>
            <br></br>

            <h1 className="singleproductheader">{directproduct.subtypename ? `${directproduct.type} - ${directproduct.subtypename}` : directproduct.type}</h1>
            <p className="singleproductgoldclr">
              Code :&nbsp;
              <span className="singleproductdetailsbold">
                {directproduct.code || directproduct.samplecode}
              </span>
            </p>
            <p className="singleproductgoldclr">
              GOLD WEIGHT :&nbsp;
              <span className="singleproductdetailsbold">{directproduct.netwt || directproduct.sampledata?.netwt} gms</span>
            </p>
            <p className="singleproductgoldclr"> KARAT : <span className="singleproductdetailsbold">{directproduct.purity || directproduct.sampledata?.goldkt} KT</span> </p>
            <p className="singleproductgoldclr"> QUALITY : <span className="singleproductdetailsbold">{directproduct.issueddiamonddetails?.[0]?.quality || " "}</span> </p>


            <p className="singleproductgoldclr"> DIAMOND Details : <span className="singleproductdetailsregular">
              {(directproduct.shapeWiseDiamonds || []).map(diamond => {
                // total = total + parseFloat(diamond.diamondweight);
                // setTotalWeight((prevTotalWeight) => prevTotalWeight + parseFloat(diamond.diamondweight));
                return (
                  <React.Fragment>
                    <hr></hr>
                    <div className="namevaluecontainer">
                      <span>
                        {diamond.shape}
                      </span>
                      <span>
                        {diamond.totalcarat} Ct
                      </span>
                    </div>
                  </React.Fragment>
                )
              })}
              <hr></hr>
            </span></p>
            <p className="singleproductgoldclr"><span className="singleproductdetailsregular">
              <div className="namevaluecontainer singleproductdetailsbold maincolor">
                <span>
                  Total WEIGHT
                </span>
                <span>
                  {directproduct.stock?.totaldiamondwt?.toFixed(2) || directproduct.sampledata?.totaldiamondwt?.toFixed(2) || 0} ct
                </span>
              </div>
              <hr></hr>
            </span></p>

            <div className="whiteinfobg">
              <h6 className="contacttext">CONTACT US FOR MORE INFORMATION</h6>
            </div>
            <br />
            <p className="singleproductdetailsbold">+91 8850286201</p>
            <p className="singleproductdetailsbold">+91 9892153550</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DirectSingleProduct;
